import type {
  ComparatorFilters, SortKey, SortDir, DailyLossFilter, RatingBand, DrawdownType,
} from "./types";
import { DRAWDOWN_TYPES } from "./types";
import { defaultFilters } from "./filtering";

const SORT_KEYS: SortKey[] = ["price", "rating", "size", "firm", "activation"];
const DAILY: DailyLossFilter[] = ["all", "none", "defined"];
const BANDS: RatingBand[] = ["all", "high", "mid", "low"];

export function filtersToParams(f: ComparatorFilters): URLSearchParams {
  const d = defaultFilters();
  const p = new URLSearchParams();
  if (f.search.trim()) p.set("q", f.search.trim());
  if (f.firmSlugs.length) p.set("firm", f.firmSlugs.join(","));
  if (f.sizesK.length) p.set("size", f.sizesK.join(","));
  if (f.accountTypes.length) p.set("type", f.accountTypes.join(","));
  if (f.drawdownTypes.length) p.set("dd", f.drawdownTypes.join(","));
  if (f.platforms.length) p.set("plat", f.platforms.join(","));
  if (f.dailyLoss !== d.dailyLoss) p.set("daily", f.dailyLoss);
  if (f.ratingBand !== d.ratingBand) p.set("rating", f.ratingBand);
  if (f.maxPrice != null) p.set("max", String(f.maxPrice));
  if (f.sortKey !== d.sortKey) p.set("sort", f.sortKey);
  if (f.sortDir !== d.sortDir) p.set("dir", f.sortDir);
  return p;
}

const list = (v: string | null): string[] => (v ? v.split(",").filter(Boolean) : []);

export function paramsToFilters(p: URLSearchParams): ComparatorFilters {
  const d = defaultFilters();
  const sortKey = p.get("sort") as SortKey | null;
  const daily = p.get("daily") as DailyLossFilter | null;
  const band = p.get("rating") as RatingBand | null;
  const dir = p.get("dir");
  const max = p.get("max");
  const maxN = max != null && Number.isFinite(Number(max)) ? Number(max) : null;
  return {
    search: p.get("q") ?? "",
    firmSlugs: list(p.get("firm")),
    sizesK: list(p.get("size")).map(Number).filter((n) => Number.isFinite(n)),
    accountTypes: list(p.get("type")).filter((v): v is "eval" | "direct" => v === "eval" || v === "direct"),
    drawdownTypes: list(p.get("dd")).filter((v): v is DrawdownType =>
      (DRAWDOWN_TYPES as readonly string[]).includes(v)),
    platforms: list(p.get("plat")),
    dailyLoss: daily && DAILY.includes(daily) ? daily : d.dailyLoss,
    ratingBand: band && BANDS.includes(band) ? band : d.ratingBand,
    maxPrice: maxN,
    sortKey: sortKey && SORT_KEYS.includes(sortKey) ? sortKey : d.sortKey,
    sortDir: dir === "asc" || dir === "desc" ? (dir as SortDir) : d.sortDir,
  };
}
